import api from '@/sui/api/api'

export default function (store, prefix, router) {
  api.interceptors.request.use(config => {
    let token = store.getters[`${prefix}/token`]
    if (token !== '') {
      config.headers.common['Authorization'] = 'Bearer ' + token
    }

    return Promise.resolve(config)
  }, undefined)

  api.interceptors.response.use(undefined, err => {
    if (err.response.status === 401) {
      store.dispatch(`${prefix}/logout`, 'expired')
      router.push({
        path: '/login',
        query: { to: router.currentRoute.fullPath }
      })
    }
    return Promise.reject(err.response)
  })
}
